module.exports = __webpack_public_path__ + "img/wilki_2.5eb58334.jpg";